import {
  addReception,
  getQueueReceptions,
  getQueueReceptionsForDoctors,
  getReceptionTypes,
  getReception,
  receptionsSearch,
  receptionDone,
  presentPatient,
  deleteReceptionRequest,
  rejectReceptionRequest,
  acceptReceptionRequest,
  // getWaitingAndInRoomAndTriageReceptions,
  getRoomReceptions,
  commitReception,
  patientTriage,
  presencePatientInRoom,
  doneTriage,
  updateRecallNumberAndEmergency,
  // remove,
  paidReception,
  sendToCashier,
  searchReceptionsForCashier,
  receptionsSearchByUnit,
  doneAccounting,
  remove, searchCurrentDayDoneReceptions, updateReceptionBeforeServiceAssign, searchCurrentDayReceptions,
  backToQueue, factorPrint
} from "@/services/endpoints/receptions";
import {oldReceptions, oldReceptionsConsulates, oldReceptionsReferrals} from "@/services/endpoints/reception";
import {
  patientPayment,
  identificationReceivedPatient,
  getAllPayments,
  removeAPayment,
  removeAnExcess,
  patientExcessReceived,
  getAllExcess,
  identificationReturnForExcess,
  returnFromServicesRendered,
  getAllReturnsForReception,
  identificationReturn,
  updatePayment,
} from "@/services/endpoints/accountingArticles";
import {
  addReceptionServices,
  getReceptionServices,
  startDoctorPresence,
  endDoctorPresence,
  deleteReceptionService,
  updateDiscountGroup
} from "@/services/endpoints/receptionServices";

import { getOneRoom } from "@/services/endpoints/room";
import { searchUsers } from "@/services/endpoints/users";

import {
  addReceptionCallingDoctor,
  updateReceptionCallingDoctor,
  deleteReceptionCallingDoctor
} from "@/services/endpoints/receptionCallingDoctors";

export default {

  setCallingDoctors : ({commit},payload) =>{
    commit('SET_CALLING_DOCTORS', payload)
  },

  async addReceptionCallingDoctor({ commit }, payload) {
    try {
      let res = await addReceptionCallingDoctor(payload.receptionId,payload.data);
      if (res) {
        return res.data;
      } else {
        throw {};
      }
    } catch (err) {
      throw err;
    }
  },

  async deleteReceptionCallingDoctor({ commit }, payload) {
    try {
      let res = await deleteReceptionCallingDoctor(payload.receptionId,payload.data);
      if (res) {
        return res.data;
      } else {
        throw {};
      }
    } catch (err) {
      throw err;
    }
  },

  async updateReceptionCallingDoctor({ commit }, payload) {
    try {
      let res = await updateReceptionCallingDoctor(payload.receptionId,payload.data);
      if (res) {
        return res.data;
      } else {
        throw {};
      }
    } catch (err) {
      throw err;
    }
  },

  //------------------------------------------

  async addReception({ commit }, payload) {
    try {
      let res = await addReception(payload);
      if (res) {
        return res.data;
      } else {
        throw {};
      }
    } catch (err) {
      throw err;
    }
  },
  async addReceptionServices({ commit }, payload) {
    try {
      let promises = [];
      payload.forEach((p) => {
        promises.push(addReceptionServices(p));
      });
      let res = await Promise.all(promises).then((value) => {
        return value;
      });
      if (res.length == payload.length) {
        return res;
      } else {
        throw new Error("submitted numbers :", res.length);
      }
    } catch (err) {
      
      throw err;
    }
  },
  async getQueueReceptions({ commit }, unitId) {
    try {
      let res = await getQueueReceptions(unitId);
      commit("SET_RECEPTIONS", res.data.receptions);
      commit("SET_NOW_TIME", res.data.nowTime);
      // return res.data;
      if (res) return res.data;
    } catch (err) {
      throw new Error(err);
    }
  },
  async getQueueReceptionsForDoctors({ commit }, unitId) {
    try {
      let res = await getQueueReceptionsForDoctors(unitId);
      commit("SET_RECEPTIONS", res.data.receptions);
      commit("SET_NOW_TIME", res.data.nowTime);
      if (res) return res.data;
    } catch (err) {
      throw new Error(err);
    }
  },
  async getReceptionTypes({ commit }) {
    try {
      let res = await getReceptionTypes();
      commit("SET_RECEPTION_TYPES", res.data);
      // return res.data;
      if (res) return res.data;
    } catch (err) {
      throw new Error(err);
    }
  },
  // getWaitingAndInRoomAndDoneReceptions({ commit },unitId) {
  //     try {
  //         getWaitingAndInRoomAndDoneReceptions(unitId).then(res => {
  //             commit('SET_RECEPTIONS', res.data.receptions)
  //             commit('SET_NOW_TIME', res.data.nowTime)
  //         }).catch(err => {
  //             throw err;
  //         });
  //     }
  //     catch (err) {
  //         throw new Error(err)
  //     }
  // },

  async receptionsSearch({ commit }, payload) {
    try {
      let res = await receptionsSearch(payload);
      if (res) return res.data;
    } catch (err) {
      throw new Error(err);
    }
  },
  async receptionsSearchByUnit({ commit }, payload) {
    try {
      let res = await receptionsSearchByUnit(payload);
      if (res) return res.data;
    } catch (err) {
      throw new Error(err);
    }
  },
  async receptionsCashierSearch({ commit }, payload) {
    try {
      let res = await searchReceptionsForCashier(payload);
      if (res) commit("SET_TOTAL", res.data.total);
      return res.data;
    } catch (err) {
      throw new Error(err);
    }
  },
  // async getWaitingAndInRoomAndTriageReceptions({ commit }, payload) {
  async getRoomReceptions({ commit }, payload) {
    try {
      // let res = await getWaitingAndInRoomAndTriageReceptions(payload);
      let res = await getRoomReceptions(payload);
      if (res) return res.data;
    } catch (err) {
      throw new Error(err);
    }
  },
  async getReception({ commit }, receptionId) {
    try {
      let res = await getReception(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async deleteReceptionRequest({ commit }, receptionId) {
    try {
      let res = await deleteReceptionRequest(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async rejectReceptionRequest({ commit }, receptionId) {
    try {
      let res = await rejectReceptionRequest(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async acceptReceptionRequest({ commit }, receptionId) {
    try {
      let res = await acceptReceptionRequest(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async doneAccounting({ commit }, receptionId) {
    try {
      let res = await doneAccounting(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async oldReceptionsConsulates({ commit }, nationalCode) {
    try {
      let res = await oldReceptionsConsulates(nationalCode);
      if (res) {
        commit("SET_OLD_RECEPTIONS_CONSULATES", res.data.data);
        return res.data.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async oldReceptionsReferrals({ commit }, nationalCode) {
    try {
      let res = await oldReceptionsReferrals(nationalCode);
      if (res) {
        commit("SET_OLD_RECEPTIONS_REFERRALS", res.data.data);
        return res.data.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getReceptionServices({ commit, dispatch }, receptionId) {
    try {
      let res = await getReceptionServices(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async startDoctorPresence({ commit }, serviceId) {
    try {
      let res = await startDoctorPresence(serviceId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async endDoctorPresence({ commit }, serviceId) {
    try {
      let res = await endDoctorPresence(serviceId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async deleteReceptionService({ commit }, payload) {
    try {
      let res = await deleteReceptionService(payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async removeAPayment({ commit }, payload) {
    try {
      let res = await removeAPayment(
        payload.relatedArticles,
        payload.accountingId
      );
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async removeAnExcess({ commit }, payload) {
    try {
      let res = await removeAnExcess(
        payload.relatedArticles,
        payload.accountingId
      );
      if (res) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async receptionDone({ commit }, payload) {
    try {
      let res = await receptionDone(payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async presentPatient({ commit }, receptionId) {
    try {
      let res = await presentPatient(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async identificationReturnForExcess({ commit }, payload) {
    try {
      let res = await identificationReturnForExcess(payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      // 
      throw new Error(err);
    }
  },
  async returnFromServicesRendered({ commit }, payload) {
    try {
      let res = await returnFromServicesRendered(payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      // 
      throw new Error(err);
    }
  },
  async identificationReturn({ commit }, payload) {
    try {
      let res = await identificationReturn(payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      // 
      throw new Error(err);
    }
  },
  async doneTriage({ commit }, receptionId) {
    try {
      let res = await doneTriage(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      // 
      throw new Error(err);
    }
  },
  async patientTriage({ commit }, receptionId) {
    try {
      let res = await patientTriage(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async presencePatientInRoom({ commit }, receptionId) {
    try {
      let res = await presencePatientInRoom(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async patientPayment({ commit }, payments) {
    try {
      let promises = [];
      payments.forEach((p) => {
        promises.push(patientPayment(p));
      });
      let res = await Promise.all(promises).then((value) => {
        return value;
        // // console.log(value);
      });
      // let res = await patientPayment(payment);
      if (res.length == payments.length) {
        return res;
      }
    } catch (err) {
      
      throw new Error("submitted numbers :", res.length);
    }
  },
  async patientExcessReceived({ commit }, excesses) {
    try {
      let promises = [];
      excesses.forEach((e) => {
        promises.push(patientExcessReceived(e));
      });
      // let res = [];
      // for(let i=0; i < promises.length; ){
      //   // console.log(i,i)
      //   let response = await promises[i];
      //   if (response){
      //     // console.log(response)
      //     ++i;
      //     res.push(response)
      //
      //   }
      // }
      let res = await Promise.all(promises).then((value) => {
        return value;
        // // console.log(value);
      });
      // let res = await patientPayment(payment);
      if (res.length === excesses.length) {
        return res;
      }
    } catch (err) {
      
      throw new Error("submitted numbers :", res.length);
    }
  },
  async getAllPayments({ commit }, getTheAmountAccountingDocumentId) {
    try {
      let res = await getAllPayments(getTheAmountAccountingDocumentId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getAllExcess({ commit }, excessReceivedAccountingDocumentId) {
    try {
      let res = await getAllExcess(excessReceivedAccountingDocumentId);
      if (res.data) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async getAllReturnsForReception({ commit }, documentId) {
    try {
      let res = await getAllReturnsForReception(documentId);
      if (res) {
        return res.data.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async commitReception({ commit }, receptionId) {
    try {
      let res = await commitReception(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async sendToCashier({ commit }, receptionId) {
    try {
      let res = await sendToCashier(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      
      throw new Error(err);
    }
  },
  async identificationReceivedPatient({ commit }, payments) {
    try {
      let promises = [];
      payments.forEach((p) => {
        promises.push(identificationReceivedPatient(p));
      });
      let res = await Promise.all(promises).then((value) => {
        return value;
      });
      if (res.length == payments.length) {
        return res;
      } else {
        throw new Error("submitted numbers :", res.length);
      }
    } catch (err) {
      
      throw new Error(err);
    }
    // try {
    //   let res = await identificationReceivedPatient(payment);
    //   if (res) {
    //     return res.data;
    //   }
    // } catch (err) {
    //   
    //   throw new Error(err);
    // }
  },
  async addVisitService({ commit }, payload) {
    try {
      let res = await addReceptionServices(payload);
      if (res) {
        return res.data;
      } else {
        throw {};
      }
    } catch (err) {
      throw err;
    }
  },

  async updateRecallNumberAndEmergency({ commit }, payload) {
    try {
      let res = await updateRecallNumberAndEmergency(payload);
      if (res) {
        return res.data;
      } else {
        throw {};
      }
    } catch (err) {
      throw err;
    }
  },

  async remove({ commit }, payload) {
    try {
      let res = await remove(payload);
      if (res) {
        return res.data;
      } else {
        throw {};
      }
    } catch (err) {
      throw err;
    }
  },
  async updateReceptionBeforeServiceAssign({ commit }, payload) {
    try {
      let res = await updateReceptionBeforeServiceAssign(payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      throw err;
    }
  },

  async paidReception({ commit }, receptionId) {
    try {
      let res = await paidReception(receptionId);
      if (res) {
        return res.data;
      }
    } catch (err) {
      // 
      throw new Error(err);
    }
  },
  async searchCurrentDayDoneReceptions({ commit }, payload) {
    try {
      let res = await searchCurrentDayDoneReceptions(payload);
      if (res) {
        commit('SET_DONE_RECEPTIONS_FOR_THIS_ROOM',[{_id: 0}])
        commit('SET_DONE_RECEPTIONS_FOR_THIS_ROOM',_.cloneDeep(JSON.parse(JSON.stringify(res.data.data))))
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async searchCurrentDayReceptions({ commit }, payload) {
    try {
      let res = await searchCurrentDayReceptions(payload);
      if (res) {
        commit('SET_CURRENT_DAY_RECEPTIONS',res.data.data)
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async backToQueue({ commit }, payload) {
    try {
      let res = await backToQueue(payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async updateDiscountGroup({ commit }, payload) {
    try {
      let res = await updateDiscountGroup(payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async factorPrint({ commit }, payload) {
    try {
      let res = await factorPrint(payload)

      if (res) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },
  async updatePayment({ commit }, payload) {
    try {
      let res = await updatePayment(payload)

      if (res) {
        return res.data;
      }
    } catch (err) {
      throw new Error(err);
    }
  },

};
